import React from "react";
import "./about.css";
import ME from "../../assets/me-about.jpg";
import { FaAward } from "react-icons/fa";
import { FiUsers } from "react-icons/fi";
import { VscFolderLibrary } from "react-icons/vsc";

const About = () => {
  return (
    <section id="about">
      <h5>Get To Know</h5>
      <h2>About Me</h2>

      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
            <img src={ME} alt="About Image" />
          </div>
        </div>

        <div className="about__content">
          <div className="about__cards">
            <article className="about__card">
              <FaAward className="about__icon" />
              <h5>Experience</h5>
              <small>6+ Years Working</small>
            </article>

            <article className="about__card">
              <FiUsers className="about__icon" />
              <h5>Clients</h5>
              <small>50+ Worldwide</small>
            </article>

            <article className="about__card">
              <VscFolderLibrary className="about__icon" />
              <h5>Projects</h5>
              <small>20+ Completed</small>
            </article>
          </div>

          <p>
            I have been working as a software developer for over 6 years. I
            mainly developed iOS application using SwiftUI, and websites using
            WordPress and React. I have also developed backend using Node.js and
            Python.
          </p>
          <p>
            Teaching software development is also my side business. I have been
            holding offline and online courses about SwiftUI and iOS app
            development in a university in Hong Kong. Feel free to contact me
            for any teaching collaboration.
          </p>
          <a href="#contact" className="btn btn-primary">
            CONTACT ME
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
